<template>
  <div>
    <div class="login">
      <div class="login__logo"></div>
      <LoginBg />
      <div class="login__box">Verifying your registration...</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoginBg from "@/components/login/LoginBg.vue";

export default {
  name: "Verify",
  components: {
    LoginBg,
  },
  methods: {
    ...mapActions(["verifyRegistration"]),
  },
  async mounted() {
    await this.$store.dispatch("toggleLoader", true);
    try {
      await this.verifyRegistration(this.$route.query.token);
      await this.$store.dispatch("toggleLoader", false);
      this.$toast.success(
        this.$t("messages.user-account.registration-verified")
      );
      this.$router.push({ name: "Login" });
    } catch (e) {
      this.$toast.error(
        this.$t("messages.user-account.registration-verify-response", {
          msg: e,
        })
      );
      window.console.log(e.response.data.msg);
      await this.$store.dispatch("toggleLoader", false);
    }
  },
};
</script>

<style>
</style>
